import styled from 'styled-components';

export const FontProvider = styled.div`
  font-family: ${({ fontIsDisabled }) =>
    !fontIsDisabled &&
    "'Archivo', -apple-system, BlinkMacSystemFont, sans-serif"};
`;
